
import { Component, OnInit } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { ClipboardService } from 'ngx-clipboard';


@Component({
    selector: "szz-error-toastr",
    templateUrl: "./error-toastr.component.html",
    styleUrls: ["./error-toastr.component.scss"],
    imports: []
})
export class ErrorToastrComponent extends Toast implements OnInit {
  showFullMessage = false;
  isCopiedToClipboard = false;

  constructor(
    public override toastrService: ToastrService,
    public override toastPackage: ToastPackage,
    private clipboardService: ClipboardService
  ) {
    super(toastrService, toastPackage);
  }

  ngOnInit(): void {}

  showMessageDetails() {
    this.showFullMessage = !this.showFullMessage;
  }

  copyToClipboard(text: string) {
    this.clipboardService.copy(text);
    this.isCopiedToClipboard = true;

    setTimeout(() => {
      this.isCopiedToClipboard = false;
    }, 3000);
  }

    manipulateWithErrorText(text: string) {
    if (text && text.length > 110) {
      return text.substring(0, 110) + '...';
    } else {
      return text;
    }
  }
}
